if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}




// if (!customElements.get('variant-selects')) {
//   customElements.define(
//     'variant-selects',
//     class VariantSelects extends HTMLElement {
//       constructor() {
//         super();
//       }

//       get selectedOptionValues() {
//         return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
//           ({ dataset }) => dataset.optionValueId
//         );
//       }

//       getInputForEventTarget(target) {
//         return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
//       }


//       connectedCallback() {
//   this.addEventListener('change', (event) => {
//     const target = this.getInputForEventTarget(event.target);
//     if (target.value === '') return;

//     this.updateSelectedSwatchValue(event);

//     FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
//       data: {
//         event,
//         target,
//         selectedOptionValues: this.selectedOptionValues,
//       },
//     });
//   });
// }



//       updateSelectedSwatchValue({ target }) {
//         const { value, tagName } = target;

//         if (tagName === 'SELECT' && target.selectedOptions.length) {

//           const previouslySelected = Array.from(target.options)
//   .find((option) => option.getAttribute('selected'));

// if (previouslySelected) {
//   previouslySelected.removeAttribute('selected');
// }
// const placeholderOption = target.querySelector('option[value=""]');
// if (placeholderOption) {
//   placeholderOption.removeAttribute('selected');
// }



//           const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
//           const selectedDropdownSwatchValue = target
//             .closest('.product-form__input')
//             .querySelector('[data-selected-value] > .swatch');
//           if (!selectedDropdownSwatchValue) return;
//           if (swatchValue) {
//             selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
//             selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
//           } else {
//             selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
//             selectedDropdownSwatchValue.classList.add('swatch--unavailable');
//           }

//           selectedDropdownSwatchValue.style.setProperty(
//             '--swatch-focal-point',
//             target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
//           );
//         } else if (tagName === 'INPUT' && target.type === 'radio') {
//           const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
//           if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
//         }
//       }
//     }
//   );
// }
// document.addEventListener('DOMContentLoaded', () => {
//   const addBtn = document.querySelector('[name="add"]');
//   const variantIdInput = document.querySelector('[name="id"]');
//   const selects = document.querySelectorAll('variant-selects select');

//   // Disable button at start
//   addBtn.disabled = true;

//   selects.forEach(select => {
//     select.addEventListener('change', () => {
//       // If placeholder chosen, keep disabled
//       if (select.value === '') {
//         addBtn.disabled = true;
//         variantIdInput.value = '';
//         return;
//       }

//       // Check if all dropdowns have real values
//       const allSelected = Array.from(selects).every(s => s.value !== '');

//       // If all selected, activate Add to Cart
//       if (allSelected) {
//         const selectedVariant = window?.FoxTheme?.variantHelper?.getSelectedVariant?.();
//         if (selectedVariant) {
//           variantIdInput.value = selectedVariant.id;
//           addBtn.disabled = false;
//         }
//       } else {
//         addBtn.disabled = true;
//         variantIdInput.value = '';
//       }
//     });
//   });

//   // Listen for FoxTheme variant update
//   FoxTheme.pubsub.subscribe(
//     FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
//     ({ data }) => {
//       const selects = document.querySelectorAll('variant-selects select');

//       selects.forEach(select => {
//         // If placeholder exists and a real option is selected
//         if (select.value !== '' && select.querySelector('option[value=""]')) {
//           select.querySelector('option[value=""]').disabled = true;
//           select.querySelector('option[value=""]').removeAttribute('selected');
//         }

//        // Force the select to show the actual selected value
// const selectedValue = select.value;

// // Disable placeholder
// const placeholder = select.querySelector('option[value=""]');
// if (placeholder) {
//   placeholder.disabled = true;
//   placeholder.removeAttribute('selected');
// }

// // Force UI to stick to selected variant
// setTimeout(() => {
//   select.value = selectedValue;
// }, 10);

//       });
//     }
//   );
// });
